import styles from "./App.module.css"
import {useAuth} from "./hooks/useAuth";
import {setIsMobile, setProfile, useGlobalDispatch, useGlobalState} from "./context/GlobalState";
import {HashRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import {Suspense, useEffect} from "react";
import LoginPage from "./components/LoginPage/LoginPage";
import ErrorMessage from "./components/ErrorMessage/ErrorMessage";
import InfoMessage from "./components/InfoMessage/InfoMessage";
import {TbCircleDotted} from "react-icons/tb";
import NavBar from "./components/NavBar/NavBar";
import HomePage from "./components/Home/Home";
import Invoice from "./components/Invoice/Invoice";
import { getProfile} from "./services/api";
import Monitor from "./components/Monitor/Monitor";
import {AiOutlineLoading3Quarters} from "react-icons/ai";
import Maintenance from "./components/Maintenance/Maintenance";
import Request from "./components/./Request/Request";

function App() {
  const {user, isAuthenticated,} = useAuth();
  const dispatch = useGlobalDispatch();
  const {loading, theme} = useGlobalState();

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  useEffect(()=> {
    const loadProfile = async () => {
      if (!isAuthenticated || !user) return;
      try {
        const profile = await getProfile();
        dispatch(setProfile(profile));
      } catch (error) {
        console.log("Error: ", error);
      }
    }
    loadProfile()
  }, [user]);

  useEffect(() => {
    const mediaQueryList = window.matchMedia("(max-width: 768px)");
    const documentChangeHandler = () => {
      dispatch(setIsMobile(mediaQueryList.matches));
    }
    mediaQueryList.addEventListener("change", documentChangeHandler);
    return () => {
      mediaQueryList.removeEventListener("change", documentChangeHandler);
    }
  }, []);

  if (!isAuthenticated()) {
    return <LoginPage/>;
  }

  return (
      <Suspense fallback={<div>Loading...</div>}>
        <Router>
          <ErrorMessage/>
          <InfoMessage/>
          <div className={styles["app"]}>
            <div className={styles["nav-bar"]}>
              <NavBar/>
            </div>
            <div className={styles["main-content-container"]}>
              <Routes>
                <Route path="/home" element={<HomePage doc_type={null}/>}/>
                <Route path="/invoice" element={<Invoice/>}/>
                <Route path="/request" element={<Request/>}/>
                <Route path="/maintenance" element={<Maintenance/>}/>
                <Route path="/" element={<Navigate to="/home"/>}/> {/* Default route */}
              </Routes>
              {loading && <div className={"loading"}>
                <AiOutlineLoading3Quarters  />
              </div>}
            </div>
            <div className={styles["monitor-area"]}>
              <Monitor/>
            </div>
          </div>
        </Router>
      </Suspense>
  );
}

export default App;
